import { arrayOf, object, shape, string } from 'prop-types';

export default shape({
    objects: arrayOf(object),
    version: string,
    background: string,
    savedColor: string,
});
